let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2rHxz")).then(() => parcelRequire('g5gkO'));